export const BUILD_VERSION = '1775140477';
